/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Delete_DescriptionInputs */

const es_feedback_delete_description = /** @type {(inputs: Feedback_Delete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta acción eliminará permanentemente el feedback seleccionado. No podrá recuperarse una vez confirmado.`)
};

const en_feedback_delete_description = /** @type {(inputs: Feedback_Delete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action will permanently delete the selected feedback. It cannot be recovered once confirmed.`)
};

/**
* | output |
* | --- |
* | "This action will permanently delete the selected feedback. It cannot be recovered once confirmed." |
*
* @param {Feedback_Delete_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_delete_description = /** @type {((inputs?: Feedback_Delete_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Delete_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_delete_description(inputs)
	return en_feedback_delete_description(inputs)
});
export { feedback_delete_description as "feedback.delete.description" }